import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {LoggerService} from '@app/core/services/logger.service'

import {Permission} from './permission.interface'

export {Permission}

@Injectable()
export class PermissionService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getPermissions(): Observable<Permission[]> {
    const url = 'api://Permissions'

    return this.http.get<Permission[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }
}
